import { apiAuth, apiResponseType } from ".";

export const getBankAccountsData = (page: number = 1): apiResponseType =>
  apiAuth.get(`bank-accounts?page=${page}`);

export const registerBankAccountData = (data) =>
  apiAuth.postForm("/bank-accounts/store", data) as apiResponseType;

export const deleteBankAccountData = (id: string) =>
  apiAuth.delete(`bank-accounts/${id}/destroy`) as apiResponseType;

export const updateBankAccountData = (id: string, data) =>
  apiAuth.put(`bank-accounts/${id}/update`, data) as apiResponseType;

export const getShowBankAccount = (id: string) =>
  apiAuth.get(`bank-accounts/${id}/show`) as apiResponseType;

export const searchBankAccountData = (params: { name: string }): apiResponseType =>
  apiAuth.get(`bank-accounts?name=${params.name}`);

export const setStatusBankAccount = (id: string) =>
  apiAuth.put(`bank-accounts/${id}/toggle-status`) as apiResponseType;

export const getSelectBankAccounts = (params?: object) => {
  const searchParams = new URLSearchParams();
  
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value) searchParams.append(key, value);
    });
  }

  return apiAuth.get(
    `bank-accounts/select?${searchParams.toString()}`
  ) as apiResponseType;
};

export const getSelectBanks = () => 
  apiAuth.get(`banks/select`) as apiResponseType; 